const SET_SCROLL_POSITION = '/page/rfids/grid/SET_SCROLL_POSITION'
const SET_WARNING = '/page/rfids/grid/SET_WARNING'
const REMOVE_WARNING = '/page/rfids/grid/REMOVE_WARNING'
const REPLACE_WINDOW_HANDLER = '/page/rfids/grid/REPLACE_WINDOW_HANDLER'
const UPDATE_MESSAGE_DISPLAY_HANDLER = '/page/rfids/grid/UPDATE_MESSAGE_DISPLAY_HANDLER'
const ADD_FORM_DISPLAY_HANDLER = '/page/rfids/grid/ADD_FORM_DISPLAY_HANDLER'
const UPDATE_FORM_DISPLAY_HANDLER = '/page/rfids/grid/UPDATE_FORM_DISPLAY_HANDLER'


export default function reducer(state, action) {
    const defaultState = {
        scrollPosition: 0,
        warning: null,
        showReplaceWindow: false,
        showUpdateMessage: false
    }

    if (!state) { state = defaultState }

    switch (action.type) {
        case SET_SCROLL_POSITION:
            return {
                ...state,
                scrollPosition: action.data
            }
        case SET_WARNING:
            return {
                ...state,
                warning: {
                    rfid: action.rfid,
                    reqInfo: action.data
                }
            }
        case REMOVE_WARNING:
            return {
                ...state,
                warning: null
            }
        case REPLACE_WINDOW_HANDLER:
            return {
                ...state,
                showReplaceWindow: action.data
            }
        case UPDATE_MESSAGE_DISPLAY_HANDLER:
            return {
                ...state,
                showUpdateMessage: action.data
            }
        case ADD_FORM_DISPLAY_HANDLER:
            return {
                ...state,
                showAddForm: action.data
            }
        case UPDATE_FORM_DISPLAY_HANDLER:
            return {
                ...state,
                showUpdateForm: action.data
            }
        default: return state
    }
}

export const setScroll = value => {
    return {
        type: SET_SCROLL_POSITION,
        data: value
    }
}
export const setWarning = (rfid, value) => {
    return {
        type: SET_WARNING,
        rfid: rfid,
        data: value
    }
}
export const removeWarning = () => {
    return {
        type: REMOVE_WARNING
    }
}
export const replaceWindowDisplayHandler = value => {
    return {
        type: REPLACE_WINDOW_HANDLER,
        data: value
    }
}
export const updateMessageDisplayHandler = value => {
    return {
        type: UPDATE_MESSAGE_DISPLAY_HANDLER,
        data: value
    }
}


export const addFormDisplayHandler = value => {
    return {
        type: ADD_FORM_DISPLAY_HANDLER,
        data: value
    }
}
export const updateFormDisplayHandler = value => {
    return {
        type: UPDATE_FORM_DISPLAY_HANDLER,
        data: value
    }
}
